import { DefaultValue } from '../../../enums/defaultValue'

export const MODAL_RENDER_TRANSITION_DURATION = DefaultValue.TransitionDuration
